export const INSIGHTS_RESULTS_PERMISSION_KEY = 'insightsResultsVisibility'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * Resolve the dedicated Results visibility setting. Existing roles keep their
 * previous resource-derived visibility until an administrator saves an
 * explicit value for this permission.
 */
export function canViewInsightsResults(
  permissions: unknown,
  legacyResourceVisibility: boolean
): boolean {
  const explicit = isRecord(permissions) ? permissions[INSIGHTS_RESULTS_PERMISSION_KEY] : undefined
  return typeof explicit === 'boolean' ? explicit : legacyResourceVisibility
}
